import styled from "styled-components";
import { getTheme, themed, Flow, Stream, Icon, Text, } from "@bracket/ui";
import { useVaults } from "@bracket/platform/store";
import type { VaultIdentifier } from "@bracket/platform/types";
import type { FunctionComponent, CSSProperties } from "react";

export declare type VaultDenominatorProps = {
	vault: VaultIdentifier;
};

export const VaultDenominator: FunctionComponent<VaultDenominatorProps> = ({ vault, }: VaultDenominatorProps) => {
	themed();

	const { ready, available, } = useVaults();
	if(!ready) return null;

	const V = available.find((v) => v.address === vault || v.symbol === vault);
	if(!V) return null;

	const {
		denomination: { symbol, label, logo: tokenLogo },
		chain: { name, logo: chainLogo },
		kyc_required,
	} = V;


	

	return (
		<Base>
			<Left>
				<Inner>
					<img src={tokenLogo} alt={symbol} crossOrigin="anonymous"  />
					<Text size="md">{label}</Text>
				</Inner>
				<Inner>
					<Icon icon="Ethereum" />
					<Text size="md">{name}</Text>
				</Inner>
			</Left>
			<Right>
			{/* {
				// TODO: unstab
				false && kyc_required && (
					<Inner $align="flex-start" $right>
						<KycBar>
							<Tooltip message={"This vault is subject to KYC verification"}>
								<KycChip>
									<Typography variant="paragraphXL" color={"#bbb"}>
										<KycTypography>
											<div style={{ marginTop: "-5px", marginRight: "-3px" }}>
												<FaceIcon color="#bbb" />
											</div>
											KYC
										</KycTypography>
									</Typography>
								</KycChip>
							</Tooltip>
						</KycBar>
					</Inner>
				)
			} */}
			</Right>
		</Base>
	);
};



const Base = styled(Stream)`
	gap: 1rem;
	min-width: 8.75em;
	@media(max-width: 1024px) {
		padding-bottom: 1rem;
		gap: 0rem;
	}
	@media(min-width: 1024px) {
		height: 100%;
		width: unset;
	}
`;

const Left = styled(Stream)`
	gap: 1rem;
`;

const Right = styled(Stream)`
`;



const Inner = styled(Flow)<{ $align?: "flex-start" | "center" | "flex-end"; $right?: boolean; }>`
	height: 100%;
	align-items: ${props => props.$align || "center"};
	gap: 0.5rem;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	margin-right: ${props => props.$right ? "0" : "undefined"};
	> img {
		height: 25px;
	}
	p {
		opacity: 0.35;
	}
	`;


const KycBar = styled.div`
	display: flex;
	transform: scale(0.75);
	transform-origin: top center;
	align-items: flex-start;
	justify-content: flex-start;
	height: 50px;
`;


const KycChip = styled.div`
	display: flex;
	padding: 4px 8px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 10000px;
	background: rgba(224, 224, 224, 0.08);
	transition: background 0.3s ease;
	&:hover {
		background: rgba(224, 224, 224, 0.16);
	}
`;


const KycTypography = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.25rem;
`;
